import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs/internal/BehaviorSubject';
import { CreateGroupOrderRequestModel } from 'src/models/requestModels/groups/CreateGroupOrderRequestModel';

@Injectable({
  providedIn: 'root'
})
export class GroupStateService {

  constructor() { }

  private defaultOrderInfo : CreateGroupOrderRequestModel = {
    create_group: null,
    sku: {
      uuid: '',
      quantity: 0
    },
    payment: {
      payment_method: undefined,
      method_uuid: null,
      user_stored_method_id: undefined,
      invoice_contact_uuid: undefined,
      invoice_contact_same_as_shipping: false,
      setup_user_method_for_future_usage: false
    },
    shipping: {
      method: '',
      carrier_office_id: undefined,
      contact_uuid: undefined,
      carrier_uuid: null
    }
  };

  private _orderInfo = new BehaviorSubject<CreateGroupOrderRequestModel>(this.defaultOrderInfo);

  public readonly orderInfo$ = this._orderInfo.asObservable();

  get orderInfo() {
    return this._orderInfo.getValue();
  }

  set orderInfo(value: CreateGroupOrderRequestModel) {
    this._orderInfo.next(value);
  }

  addNewOrderInfo(value: CreateGroupOrderRequestModel) {
    this.orderInfo = {...value};
  } 

  removeOrderInfo() {
    this.orderInfo = this.defaultOrderInfo;
  }
}
